// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import Actions from "../../../../actions/cities";
import List from "./List";

class Cities extends Component {
  componentWillMount = () => {
    this.props.dispatch(Actions.fetchCities());
  };

  onDelete = ids => {
    ids.map(id => {
      this.props.dispatch(Actions.onDelete(id)).then(() => {
        this.props.dispatch(Actions.fetchCities());
      });
    });
  };

  onFetchCity = (id) => {
    this.props.dispatch(Actions.fetchCity(id));
  }

  onNew = () => {
    this.props.dispatch(Actions.onNew());
  }

  onChangePage = value => {
    this.props
      .dispatch(Actions.onChangePage(value))
      .then(() => this.props.dispatch(Actions.fetchCities()));
  };

  onSearch = e => {
    this.props
      .dispatch(Actions.onSearch(e.target.value))
      .then(() => this.props.dispatch(Actions.fetchCities()));
  };

  render() {
    const { isLoading, isModalVisible, cities, meta, fetchParams } = this.props;
    return (
      <List
        loading={isLoading}
        isModalVisible={isModalVisible}
        cities={cities}
        meta={meta}
        fetchParams={fetchParams}
        onDelete={this.onDelete}
        onSearch={this.onSearch}
        onChangePage={this.onChangePage}
        onFetchCity={this.onFetchCity}
        onNew={this.onNew}
      />
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.cities.isLoading,
  isModalVisible: state.cities.isModalVisible,
  cities: state.cities.cities,
  meta: state.cities.meta,
  fetchParams: state.cities.fetchParams
});

export default connect(mapStateToProps)(Cities);
